import styles from './index.less'

export default props => {
    return (
        <div className={styles.container} {...props} data-log>
            <img className={styles.iconPlus} src='https://assets.sursung.com/activity/20240116/76F64B64191E4AFDBD18B037AE7FA1A01705385325079.svg' width="14" height="14" />
            <span>保存筛选条件和排序</span>
        </div>
    )
}
